"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: Boolean,
        default: undefined
    },
    bounceVelocityThreshold: {
        type: Number,
        default: undefined
    },
    contentHeight: {
        type: [Number, String],
        default: undefined
    },
    dataSource: {
        type: Object,
        default: undefined
    },
    duration: {
        type: Number,
        default: undefined
    },
    emptyTemplate: {
        type: String,
        default: undefined
    },
    enablePager: {
        type: Boolean,
        default: undefined
    },
    page: {
        type: Number,
        default: undefined
    },
    template: {
        type: String,
        default: undefined
    },
    velocityThreshold: {
        type: Number,
        default: undefined
    },

    // Events
    change: Function,
    refresh: Function
};